import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 rounded-t-[40px] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        {/* Top Section: 3 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {/* Left: Newsletter - spans 5 cols */}
          <div className="md:col-span-5">
            <h3 className="text-3xl md:text-4xl font-heading text-background-50 mb-4">
              Stay Updated
            </h3>
            <p className="text-foreground-400 text-sm mb-8 leading-relaxed max-w-sm">
              Get the latest OOPBuy spreadsheet guides, product updates, and sourcing tips delivered to your inbox.
            </p>
            <form
              data-readdy-form
              id="newsletter-form"
              action="https://readdy.ai/api/form/d8s0i6jf81iibef4biog"
              method="POST"
              className="flex flex-col sm:flex-row gap-3"
            >
              <div className="flex-1 relative">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="Your email"
                  className="w-full bg-transparent border-0 border-b border-foreground-700 pb-3 text-background-50 placeholder:text-foreground-600 text-sm outline-none focus:border-accent-500 transition-colors"
                />
              </div>
              <button
                type="submit"
                className="flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-background-50 hover:bg-background-100 transition-colors text-sm font-semibold text-foreground-950 whitespace-nowrap cursor-pointer"
              >
                Subscribe
                <i className="ri-arrow-right-line text-base"></i>
              </button>
            </form>
          </div>

          {/* Middle: Navigate - spans 3 cols */}
          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50 mb-5 uppercase tracking-wider">
              Navigate
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/oopbuy-spreadsheet-guide" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors underline decoration-foreground-700/30 hover:decoration-accent-400/50">
                Full Guide
              </Link>
              <Link to="/blog/oopbuy-vs-traditional-agents" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors underline decoration-foreground-700/30 hover:decoration-accent-400/50">
                Comparison Guide
              </Link>
              <Link to="/blog/is-spreadsheet-shopping-safe" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors underline decoration-foreground-700/30 hover:decoration-accent-400/50">
                Safety Guide
              </Link>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors underline decoration-foreground-700/30 hover:decoration-accent-400/50">
                Visit Main Store
              </a>
            </nav>
          </div>

          {/* Right: Contact - spans 4 cols */}
          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-background-50 mb-5 uppercase tracking-wider">
              Contact Info
            </h4>
            <div className="space-y-3 mb-8">
              <p className="text-sm text-foreground-400">support@oopbuyspreadsheets.cyou</p>
              <p className="text-sm text-foreground-400">Available 24/7 via spreadsheet system</p>
            </div>
            <h4 className="text-sm font-semibold text-background-50 mb-3 uppercase tracking-wider">
              Location
            </h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              Global Sourcing Network<br />
              Worldwide Shipping Available
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-14 pt-8 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-5">
            <a href="#" className="text-sm text-foreground-500 hover:text-accent-400 transition-colors underline decoration-foreground-700/30">
              <i className="ri-instagram-line"></i>
            </a>
            <a href="#" className="text-sm text-foreground-500 hover:text-accent-400 transition-colors underline decoration-foreground-700/30">
              <i className="ri-twitter-x-line"></i>
            </a>
            <a href="#" className="text-sm text-foreground-500 hover:text-accent-400 transition-colors underline decoration-foreground-700/30">
              <i className="ri-youtube-line"></i>
            </a>
          </div>
          <p className="text-xs text-foreground-600 text-center">
            &copy; {new Date().getFullYear()} OOPBuy Spreadsheets. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors underline decoration-foreground-700/30">
              Privacy Policy
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors underline decoration-foreground-700/30">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}